import { Navigate, Route, Routes } from "react-router-dom";
import { ALL_ROUTES } from "./routes/AllRoutes";
import { Auth_rouite_group } from "./routes/auth";
import { dashboard_route_group } from "./routes/dashboard";
import PrivateRouteDashboard from "./routes/private-route";
// import setAuthToken from "./utils/auth";
import { Provider } from "react-redux";
import store from "./redux/store";
import { RazorToast } from "./components/razor-reuse";
import setAuthToken from "./redux/setAuthToken";
import "react-loading-skeleton/dist/skeleton.css";
import "./components/index.css";

function App() {
  type RouteProp = {
    path: string;
    element: () => any;
    // location:
  };
  const toks = localStorage?.getItem("token") || "";
  if (toks) setAuthToken();

  return (
    <>
      <Provider store={store}>
        <Routes>
          <Route
            path="/"
            element={<Navigate to={ALL_ROUTES?.LOGIN} replace />}
          />

          {/* auth group start */}
          {Auth_rouite_group?.map((route: RouteProp, idx: number) => (
            <Route key={idx} path={route.path} element={<route.element />} />
          ))}
          {/* auth group end */}
          {/* auth group end */}
          {/* verification group start */}

          {/* verification group end */}
          {/* dashboard group start */}
          {dashboard_route_group?.map((route: RouteProp, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <PrivateRouteDashboard>
                  {<route.element />}
                </PrivateRouteDashboard>
              }
            />
          ))}
          {/* dashboard group end */}
        </Routes>
        <RazorToast />
      </Provider>
    </>
  );
}

export default App;
